import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class Services extends ChemComponent {
  	constructor(props) {
		super(props);
		
		var search = {
			SERVICE_NAME: '',
			RCH_NAME: '',
			SERVICE_TITLE: ''
		};
		
		// initialize dry ice list
		var initialServicesList = this.copyServicesList();
		initialServicesList.query.search = this.constructSearch(search);
		
		// remove add/edit column if not authorized
		if (props.user.crs.userAccessID !== 1) {
			initialServicesList.columns.splice(0, 1);
		}
		
		this.state = {
			renderKey: 1,
			servicesList: initialServicesList,
			search: search,
			searchCount: null
		};
	}
	
	copyServicesList() {
		var servicesListCopy = this.copyObject(servicesList);
		for (var i = 0; i < servicesList.columns.length; i++) {
			if (servicesList.columns[i].Header) {
				servicesListCopy.columns[i].Header = servicesList.columns[i].Header;
			}
			if (servicesList.columns[i].Cell) {
				servicesListCopy.columns[i].Cell = servicesList.columns[i].Cell;
			}
		}
		return servicesListCopy;
	}
	
	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}
	
	onSubmitSearch(event) {
		var newServicesList = this.copyServicesList();
		newServicesList.query.search = this.constructSearch(this.state.search);
		this.mergeState({ 
			servicesList: newServicesList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
	
	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: []
		};

		if (!this.isEmpty(data.SERVICE_NAME)) search.Children.push({ Attribute: 'SERVICE_NAME', Operator: 'like', StringValue: '%' + data.SERVICE_NAME + '%' });		
		if (!this.isEmpty(data.RCH_NAME)) search.Children.push({ Attribute: 'RCH_NAME', Operator: 'like', StringValue: '%' + data.RCH_NAME + '%' });
		if (!this.isEmpty(data.SERVICE_TITLE)) search.Children.push({ Attribute: 'SERVICE_TITLE', Operator: 'like', StringValue: '%' + data.SERVICE_TITLE + '%' });
		
		if (search.Children.length === 0) return null;
		return search;
	}
	
	addService() {
		this.props.navigate('/CRS/Services/new');
	}
	
	editService(jobId) {
		this.props.navigate('/CRS/Services/' + jobId);
	}
	
	render() {

		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Services',
			columns: exportColumns,
			entity: 'RECHARGES.SERVICE_LIST_VW',
			search: this.constructSearch(this.state.search),
			order: ['RCH_NAME', 'SERVICE_NAME']
		});			

		return (<>
			<Container fluid>
				<Row>
				  <Col xs={12} style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				    <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Services</span>
					<ChemEdit parent={this} columns={servicesSearch} data={this.state.search} renderKey={this.state.renderKey} 
					  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} onSubmit={(event) => this.onSubmitSearch(event)} {...this.props}>
					  <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
						<Col xs={4} style={{ marginTop: 8}}>
							{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
								{exportData.map((excelFormField, index) => {
									return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
								</OverlayTrigger>
							</form>
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
								{exportData.map((pdfFormField, index) => {
									return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
								</OverlayTrigger>
							</form>
						</Col>
						<Col xs={6}>
						  <Button id="update" variant="warning" type="submit" className="float-end">Search</Button>
						</Col>
					  </Form.Group>
					</ChemEdit>
				  </Col>
				</Row>
				<Row>
					<Col>
						<QueryTable renderKey={this.state.renderKey} parent={this} name='CRS_Services' table={this.state.servicesList}
							onResult={(data) => this.onSearchResult(data)} offsetHeight='200px' />
					</Col>
				</Row>
			</Container>
		</>);
	}
}

const servicesSearch = [
	{ Header: 'Name', accessor: 'SERVICE_NAME', row: 0, col: 0 },
	{ Header: 'Unit', accessor: 'RCH_NAME', row: 0, col: 1 },
	{ Header: 'Title', accessor: 'SERVICE_TITLE', row: 0, col: 2 }
];

const servicesList = {
	query: { entity: 'RECHARGES.SERVICE_LIST_VW', search: null, order: ['RCH_NAME', 'SERVICE_NAME'] },
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addService()} />, accessor: 'id', 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editService(props.row.values.SERVICE_ID)} />, width: 25 },
		{ Header: 'ID', accessor: 'SERVICE_ID', width: 60 },
		{ Header: 'Name', accessor: 'SERVICE_NAME', width: 250 },
		{ Header: 'Unit', accessor: 'RCH_NAME', width: 250 },
		{ Header: 'Income Title', accessor: 'SERVICE_TITLE', width: 250 },
		{ Header: 'Primary Contact', accessor: 'CONTACT1', width: 150 },
		{ Header: 'Email', accessor: 'SERVICE_EMAIL', width: 225 },
		{ Header: 'Income Acct', accessor: 'INCOME_ACCT', width: 80 },
		{ Header: 'Recharge Acct', accessor: 'RECHARGE_ACCT', width: 80 },
		{ Header: 'Monthly Upload', accessor: 'UPLOAD_FLAG', width: 70 },
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'SERVICE_ID', width: 12 },
	{ Header: 'Name', accessor: 'SERVICE_NAME', width: 50 },
	{ Header: 'Unit', accessor: 'RCH_NAME', width: 50 },
	{ Header: 'Income Title', accessor: 'SERVICE_TITLE', width: 50 },
	{ Header: 'Primary Contact', accessor: 'CONTACT1', width: 30 },
	{ Header: 'Email', accessor: 'SERVICE_EMAIL', width: 45 },
	{ Header: 'Income Acct', accessor: 'INCOME_ACCT', width: 16 },
	{ Header: 'Recharge Acct', accessor: 'RECHARGE_ACCT', width: 16 },
	{ Header: 'Monthly Upload', accessor: 'UPLOAD_FLAG', width: 14 },
];

export default withRouter(Services);